import { useState } from "react"
import { useSelector } from "react-redux"
import Button from "../../../common/Button"
import { getDownloadPDFWithUrl } from "../../../../lib/fetchApi"

const DownloadDocument = ({label, url, btnStyle }) => {

    const [loading, setLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)
    

    const downloadDocumentHandler = async () => {

        setLoading(true)
        let doc = await getDownloadPDFWithUrl(userToken, url)

        if (doc && !doc.errorMessage) {
            let file = window.URL.createObjectURL(doc);
            window.open(file, '_blank');
        }

        setLoading(false)
    }

    return <Button click={downloadDocumentHandler} isLoading={loading} btnStyle={btnStyle}>
        <i className="ti ti-printer"></i>
        {label}
    </Button>
}

export default DownloadDocument